/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Household_Unregistered_ToastInputs */

const fr_household_unregistered_toast = /** @type {(inputs: Household_Unregistered_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Désinscription de ${i?.name} validée`)
};

/**

* @param {Household_Unregistered_ToastInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const household_unregistered_toast = /** @type {((inputs: Household_Unregistered_ToastInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Household_Unregistered_ToastInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_household_unregistered_toast(inputs)
});